exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ParallaxBase[data-v-541a08d7]{height:100vh;overflow-x:hidden;overflow-y:auto;-webkit-perspective:100px;perspective:100px}.ParallaxBase[data-v-541a08d7] *{-webkit-transform-style:preserve-3d;transform-style:preserve-3d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-541a08d7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parallax/ParallaxBase.vue
// module id = Rva2
// module chunks = 1